import type {Reasons} from 'src/types/scheduler/reasons';
import type {SchedulerReasonActions} from 'src/action-creators/scheduler/reasons';

import {SET_REASONS} from 'src/action-creators/scheduler/reasons';


const initialState: Reasons = [];

export default (
  state: Reasons = initialState,
  action: SchedulerReasonActions,
): Reasons => {
  switch (action.type) {
    case SET_REASONS:
      return action.payload;
    default:
      return state;
  }
};
